<template>
  <div class="content-map-container">
    <!-- 顶部：统计卡片组件 -->
    <div class="stats-section">
      <ContentMapNum  :topData="topData"/>
    </div>

    <!-- 底部：地图展示区域 -->
    <div class="map-section">
      <div id="china-map" class="map-chart"></div>
    </div>
  </div>
</template>

<script>
import ContentMapNum from './contentMapNum.vue'
import echarts from 'echarts'
import moment from 'moment'

/**
 * 获取基础地图配置
 * @param {String} place - 地区名称
 * @returns {Object} ECharts 配置对象
 */
function getBaseMapOption(place) {
  return {
    backgroundColor: "#080A20",
    toolbox: {
      show: true,
      feature: {
        saveAsImage: { show: false }
      }
    },
    dataRange: {
      show: true,
      text: ['High', 'Low'],
      realtime: true,
      calculable: true,
      /* 默认在右侧，窄列时易挤出容器；靠左并收窄色条，减少地图区域水平外溢 */
      left: 8,
      top: 'middle',
      itemWidth: 12,
      itemHeight: 120,
      color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"]
    },
    geo: {
      map: place,
      roam: true,
      center: (place == '中国' ? [106.731761, 38.302601] : null),
      zoom: (place == '中国' ? 1.1 : 1),
      label: {
        emphasis: {
          show: true
        },
        normal: {
          show: true
        }
      }
    },
    series: [{
      type: 'scatter',
      coordinateSystem: 'geo'
    }, {
      name: '启动次数',
      type: 'map',
      geoIndex: 0,
      data: []
    }]
  }
}

/**
 * 获取地图数据配置
 * @param {Object} resData - 接口返回的数据
 * @returns {Object} ECharts 配置对象
 */
function getMapDataOption(resData) {
  return {
    dataRange: {
      show: true,
      min: resData.min,
      max: resData.max,
      text: ['高', '低'],
      realtime: false,
      calculable: true,
      left: 8,
      top: 'middle',
      itemWidth: 12,
      itemHeight: 120,
      color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"]
    },
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        
        var res1 = params.name + '<br/>'
        var myseries = resData.data
        if(myseries&&myseries.length >0){
          for (var i = 1; i < myseries.length; i++) {
            if(myseries[i]&&myseries[i].data&&myseries[i].data.length > 0){
              for (var j = 0; j < myseries[i].data.length; j++) {
                if (myseries[i].data[j].name == params.name) {
                  if (!Array.isArray(myseries[i].data[j].value)) {
                    if (Array.isArray(myseries[i].name)) {
                      res1 += myseries[i].name[0] + ':' + myseries[i].data[j].value + '<br>'
                          + myseries[i].name[1] + ':' + myseries[i].data[j].value1 + '<br>'
                    } else {
                      res1 += myseries[i].name + ':' + myseries[i].data[j].value + '</br>'
                    }
                  }
                }
            }
            }
          }
        }
       
        return res1
      }
    },
    series: resData.data,
    title: {
      backgroundColor: "#080A20",
      left: "center",
      subtextStyle: {
        fontSize: 14,
        rich: {
          yellow: {
            fontSize: 13,
            color: '#F6F9FA',
            align: 'center',
            padding: [3, 3, 3, 3],
            width: 105
          },
          blue: {
            fontSize: 20,
            fontWeight: 600,
            align: 'center',
            color: '#25F3E6',
            padding: [3, 3, 3, 3],
            width: 105
          }
        }
      }
    }
  }
}

export default {
  name: 'ContentMap',
  components: {
    ContentMapNum
  },
  data() {
    return {
      mapChart: null,
      path: 'clinic_kfsl_v2',
      resizeHandler: null,
      params: {
        "date_start": "2025-12-08 00:00:00",
        "date_end": "2025-12-08 23:59:59",
        "query_var": "",
        "query_cond": "",
        "query_value": "",
        "province": "",
      },
      area_name: ['中国'],
      topData: {
        hzzs: 0,
        yzs: 0,
        sscfl: 0,
        sssr: 0
      }
    }
  },

  mounted() {
    // 获取当前日期
    this.getCurrDate()
    // 初始化地图
    this.initMap()
    // 注册地图并初始化图表
    this.registerMapAndInit()
    
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
    }
    if (this.mapChart) {
      this.mapChart.off('click', this.handleMapClick)
      this.mapChart.dispose()
      this.mapChart = null
    }
  },
  methods: {
    /**
     * 注册地图并初始化图表
     */
    registerMapAndInit() {
      // 获取地图 GeoJSON 数据并注册
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_map_json_data_v2?name=" + this.area_name.at(-1)).then((res) => {
        if (res.data.data == "-1") {
          console.error('地图数据获取失败')
          return
        }
        // 注册地图数据到 ECharts
        echarts.registerMap(this.area_name.at(-1), res.data.data)
        if(this.mapChart){
          this.mapChart.clear()
        }
        // 初始化图表
        this.initMap()
        // 加载地图数据
        this.loadMapData(this.path)
      }).catch((err) => {
        console.error('获取地图 GeoJSON 数据失败:', err)
      })
    },
    /**
     * 初始化地图图表
     */
    initMap() {
      this.$nextTick(() => {
        const chartDom = document.getElementById('china-map')
        if (!chartDom) {
          console.error('地图容器不存在')
          return
        }
        
        this.mapChart = echarts.init(chartDom, 'dark')
        this.mapChart.setOption(getBaseMapOption(this.area_name.at(-1)))
        
        // 添加地图点击事件
        this.mapChart.on('click', this.handleMapClick)
        
        // 响应式调整
        this.resizeHandler = () => {
          if (this.mapChart) {
            this.mapChart.resize()
          }
        }
        window.addEventListener('resize', this.resizeHandler)
      })
    },
    /**
     * 加载地图数据
     */
    loadMapData(path) {
      if (!this.mapChart) {
        console.error('地图图表未初始化')
        return
      }
      // show_province_detail_kfsl_v2 clinic_kfsl_v2
      this.$http.post(process.env.VUE_APP_API_HOST + "/"+path, {
        ...this.params
      }).then((res) => {
        if (!res.data) {
          console.error('地图数据返回为空')
          return
        }
        if(path == 'clinic_kfsl_v2'){
          this.topData.hzzs = res.data.title_subtext_json.clinic_count_val
          this.topData.yzs = res.data.title_subtext_json.select_online_val
        }
        this.mapChart.setOption(getMapDataOption(res.data))
        this.getInfoData()
      }).catch((err) => {
        console.error('加载地图数据失败:', err)
      })
    },
    getCurrDate() {
      this.params.date_start = moment().startOf('day').format('YYYY-MM-DD 00:00:00')
      this.params.date_end = moment().endOf('day').format('YYYY-MM-DD 23:59:59')
    },
    /**
     * 处理地图点击事件
     */
     handleMapClick(params) {
      if (!params || !params.name) {
        return
      }
     
      this.area_name.push(params.name)
      console.log(this.area_name,'this.area_name')
      if(this.area_name.length>3){
        this.area_name = ['中国']
        this.path = 'clinic_kfsl_v2'
        this.params.province = ""
        delete this.params.cityName;
        this.registerMapAndInit()
        return
      }
      if(this.area_name.length==3){
        this.params.province = this.area_name.at(-2)
        this.params.cityName = this.area_name.at(-1)
        this.registerMapAndInit()
        this.path = 'show_province_detail_kfsl_v2'
        return
      }
      this.path = 'show_province_detail_kfsl_v2'
      this.params.province = this.area_name.at(-1)
      // 注册地图并初始化图表
      this.registerMapAndInit()
    },
    // 获取区划详细数据
    getInfoData(){
      this.$http.post(process.env.VUE_APP_API_HOST + "/get_today_cfl_realtime", {
        ...this.params
      }).then((res) => {
        this.topData.sscfl = res.data.data.cfl
        this.topData.sssr = res.data.data.fees
        console.log(res.data,'res.data')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-map-container {
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .stats-section {
    flex-shrink: 0;
    height: 120px;
    min-height: 120px;
    width: 100%;
  }

  /**
   * 地图绘图区：在父级已限定高度的前提下，再用 vh 略压一屏内地图高度，避免竖向占满过高
   */
  .map-section {
    flex: 1;
    width: 100%;
    min-height: 0;
    max-height: min(48vh, 100%);
    position: relative;
    overflow: hidden;

    .map-chart {
      width: 100%;
      max-width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
